const initialState = {entries:[{
        ascent: "127.1",
        avgHr: "151.6",
        date: "Sat, 11 Feb 2017 00:00:00 GMT",
        descent: "0",
        distance: "1596.6",
        duration: "20.63",
        id: "160",
        runningIndex: "30.48",
        stressScore: "19.63"}
]}
const newLocal = 'FETCH_ACTIVITIES'
const newLocal2 = 'DELETE_ITEM'
const newLocal3 = 'CREATE_ITEM'
const newLocal4 = 'COUNTS_FITNESS'
export default (state = [], action) => {
    switch (action.type){
        case newLocal:
            return action.payload
        case newLocal2:
            //console.log(action.payload)
            return  {...state,entries:state.entries.filter(item => item.id != action.payload)}  // {entries:state.entries.filter(item => item.id !== action.payload)}
        //case newLocal4:
        //    return {...state,entries:state.entries.map(item => item.id === action.payload ? item.count = !item.count :item )}
        default:
            return state
    }
}
//[...state.entries.filter(item => item.id !== action.payload)]